import {
  GetRecipeQuery_recipe_Recipe,
  RecipeStatus,
} from '__generated__/queries-recipe';

export const NEW_RECIPE_ID = 'NEW_RECIPE_ID';

export const getEmptyRecipe = (
  brandKey: string,
): GetRecipeQuery_recipe_Recipe => ({
  id: NEW_RECIPE_ID,
  brandKey,
  title: '',
  createdAt: '',
  status: RecipeStatus.Draft,
  instructions: '',
  advice: '',
  rawIngredients: '',
  parsedIngredients: '',
  recipeCategories: [],
  recipeTags: [],
  recipeUrls: [],
  recipeHistories: [],
});
